export const theme = {
    colors: {
      red: '#FF4D4F',           // For losses or errors
      green: '#52C41A',         // For profits only
      teal: '#2DD4BF',          // Primary accent for interactive elements
      tealDark: '#26B8A6',      // Hover state
      tealLight: 'rgba(45, 212, 191, 0.12)',  // Active background
      tealSubtle: 'rgba(45, 212, 191, 0.08)', // Hover background
      black: '#1E2D48',         // Backgrounds or text
      white: '#FFFFFF',         // Backgrounds or text
      gray: '#8899AA',          // Inactive icons
    },
  };